
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { ContactModel } from './Entities.GormCrm.Contact';
import { Model, ModelProperty } from 'models/Model';


export class CompanyContactModel extends Model<CompanyContactModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'companyContact.property.companyId' },
		{ name: 'contactId', type: 'guid', languageString: 'companyContact.property.contactId' },
		{ name: 'company', type: 'CompanyModel', languageString: 'companyContact.property.company', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'contact', type: 'ContactModel', languageString: 'companyContact.property.contact', isHidden: true, isObject: true, new: () => { return new ContactModel }, properties: () => { return ContactModel.classProperties } }
	];
	[key: string]: any;
	
	public companyId?: string;
	public contactId?: string;
	public company?: CompanyModel;
	public contact?: ContactModel;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.contactId = undefined;
		this.company = undefined;
		this.contact = undefined;
		
	}
	getProperties(){
		return CompanyContactModel.classProperties;
	}
}

